import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { MdPeopleOutline, MdEdit, MdDelete } from 'react-icons/lib/md';
import { modalStyle } from '../../constants';
import { withAuth } from '../../actions/';
import { fetchMembers } from '../../actions/project_actions';
import { formatPhoneNumber, formatEmail, getFullName } from '../../utils/';
import Avatar from '../global/Avatar';
import MemberSearch from './MemberSearch';
import MemberForm from './MemberForm';
import Consultants from './Consultants';
import { isActiveEmployee } from '../../utils/team';

class ProjectTeam extends Component {
  // static PropTypes = {
  //   fetch: PropTypes.bool,
  //   permissions: PropTypes.object.isRequired,
  //   projectId: PropTypes.string.isRequired,
  //   members: PropTypes.array.isRequired,
  //   fetchMembers: PropTypes.func.isRequired,
  // }

  constructor(props) {
    super(props);

    this.state = {
      toEdit: null,
      toDelete: null,
      warning: '',
    }

    this.closeModal = this.closeModal.bind(this);
    this.addMember = this.addMember.bind(this);
    this.editMember = this.editMember.bind(this);
    this.removeMember = this.removeMember.bind(this);
    this.saveHandler = this.saveHandler.bind(this);
    this.deleteHandler = this.deleteHandler.bind(this);
    this.errorHandler = this.errorHandler.bind(this);
    this.handleExportToExcel = this.handleExportToExcel.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { projectId } = this.props;
    if (this.props.fetch) this.props.fetchMembers(projectId);
  }

  closeModal() {
    this.setState({
      toEdit: null,
      toDelete: null,
      warning: '',
    });
  }

  addMember(user) {
    this.editMember({
      id: 0,
      member: user,
      memberId: user.id,
      projectTitleId: null,
    })
  }

  editMember(obj) {
    this.setState({ toEdit: obj });
  }

  removeMember(obj) {
    this.setState({ toDelete: obj });
  }

  deleteHandler() {
    const { projectId } = this.props;
    const memberId = this.state.toDelete.id

    const url = `/projects/${projectId}/members/${memberId}`;
    withAuth(
      { method: 'delete', url },
      () => {
        this.props.fetchMembers(projectId);
        this.closeModal()
      },
      this.errorHandler
    );
  }

  saveHandler(teamObj) {
    const { projectId } = this.props;

    let method = 'post';
    let url = `projects/${projectId}/members`;
    if (teamObj.id) {
      method = 'put';
      url = `${url}/${teamObj.id}`;
    }

    return this.makePutOrPostRequest(teamObj, method, url);
  }

  makePutOrPostRequest(teamObj, method, url) {
    const { projectId } = this.props;
    const { id, projectTitleId, memberId, email } = teamObj;
    const data = { id, projectId, projectTitleId, memberId, email }

    withAuth(
      { method, url, data },
      () => {
        this.props.fetchMembers(projectId);
        this.closeModal();
      },
      this.errorHandler
    )
  }

  errorHandler(error) {
    let warning = 'There has been an error!'
    if (error.response && error.response.status === 409) {
      warning = 'You need at least one person with edit privileges.';
    }
    this.setState({ warning });
  }

  renderWarning() {
    const { toDelete, warning } = this.state;
    const lastAction = toDelete ? 'Delete' : 'Edit';
    return (
      <div className="alert-modal">
        <h1>{lastAction} failed!</h1>
        <p>{warning}</p>
        <button className="alert-save" onClick={this.closeModal}>Got it!</button>
      </div>
    )
  }

  renderDeleteForm(toDelete) {
    const name = getFullName(toDelete.member);
    return (
      <div className="alert-modal">
        <h1>Confirm</h1>
        <p>{`Are you sure you want to remove "${name}" from this project?`}</p>
        <button className="alert-cancel" onClick={this.deleteHandler}>Yes, Delete!</button>
        <div className="modal-close" onClick={this.closeModal}>
          <span className="close"></span>
        </div>
      </div>
    )
  }

  renderEditForm(toEdit) {
    const name = getFullName(toEdit.member);
    const heading = toEdit.id
      ? `Add "${name}" to the team`
      : `Change ${name}'s role`;

    return (
      <div className="member-form modal-form">
        <h1>{heading}</h1>
        <MemberForm
          teamObj={toEdit}
          onSave={this.saveHandler}
        />
        <div className="modal-close"
          onClick={() => this.closeModal()}>
          <span className="close"></span>
        </div>
      </div>
    )
  }

  renderRowButtons(row) {
    return (
      <td>
        <button onClick={() => this.editMember(row)}>
          <span><MdEdit size={22} color='#8492a6' /></span>
        </button>
        <button onClick={() => this.removeMember(row)}>
          <span><MdDelete size={22} color='#8492a6' /></span>
        </button>
      </td>
    )
  }

  renderMembers() {
    const { members, permissions } = this.props;
    const { roleModules } = permissions.editPrivileges;

    const canEdit = roleModules !== null && roleModules.includes('Team')
      ? true : false;

    if (members.length === 0) {
      return (
        <div className="col s12">
          <div>This project has no members yet.</div>
        </div>
      )
    }

    return (
      <div className="col s12">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Person</th>
                <th>Title</th>
                <th>Email</th>
                <th>Work Phone</th>
                <th>Mobile Phone</th>
                {canEdit ? <th>Actions</th> : null}
              </tr>
            </thead>
            <tbody>
              {members.map(row => {
                const fullName = getFullName(row.member);
                return (
                  <tr key={row.id} className={isActiveEmployee(row.member) ? 'active-user' : 'inactive-user'}>
                    <td><Avatar name={fullName} isActive={isActiveEmployee(row.member)}/></td>
                    <td>{fullName}</td>
                    <td>{row.projectTitle.title}</td>
                    <td>{isActiveEmployee(row.member) ? formatEmail(row.member.email) : row.member.email}</td>
                    <td>{formatPhoneNumber(row.member.telExtension)}</td>
                    <td>{formatPhoneNumber(row.member.pagerNumber)}</td>
                    {canEdit ? this.renderRowButtons(row) : null}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderModal() {
    const { warning, toEdit, toDelete } = this.state;

    let Content = null;
    if (warning) Content = this.renderWarning();
    else if (toEdit) Content = this.renderEditForm(toEdit);
    else if (toDelete) Content = this.renderDeleteForm(toDelete);

    return (
      <Modal
        isOpen={!!Content}
        style={modalStyle}
        contentLabel="Add member"
      >
        {Content}
      </Modal>
    )
  }

  handleExportToExcel() {
    const projectId = this.props.projectId;

    let url = `projects/${projectId}/ExportProjectTeam`;
    let method = 'post';
    let responseType = 'arraybuffer';

    withAuth(
      { method, url, responseType },
      (response) => {
        var data = response.data;
        var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        var blob = new Blob([data], { type: contentType });
        var downloadUrl = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'ProjectTeam.xlsx';
        link.click();
      },
      this.errorHandler
    )
  }

  render() {
    const { projectId, permissions } = this.props;
    const { roleModules } = permissions.editPrivileges;

    const canEdit = roleModules !== null && roleModules.includes('Team')
      ? true : false;

    return (
      <div id="team" className="row-wide project-team">
        <div className="col s12">

          <h4 className="bar-bottom">
            <span><MdPeopleOutline size={20} /></span> Team
          </h4>
        </div>

        {canEdit ? <MemberSearch onAdd={this.addMember} /> : null}
        {canEdit ? this.renderModal() : null}

        {this.renderMembers()}

        <Consultants projectId={projectId} />
      </div>
    );
  }
}

ProjectTeam.propTypes = {
  fetch: PropTypes.bool,
  permissions: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  members: PropTypes.array.isRequired,
  fetchMembers: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    projectId: ownProps.projectId,
    members: state.projectsStore.members,
    permissions: state.projectsStore.permissions
  };
}

export default connect(mapStateToProps, { fetchMembers })(ProjectTeam);